import { api } from "#/lib/api-client";
import type { PermissionResponse } from "./types";

export const permissionApi = {
  /**
   * List all permissions (active and inactive), optionally filtered server-side.
   * Was calling GET /api/hr/admin/permissions, which was never mapped on the
   * backend (only POST .../activate and .../deactivate exist under that admin
   * path) — every call 404'd and silently fell back to /api/hr/permissions/options,
   * which ignores `search` entirely and drops every inactive permission. That's
   * why the search box looked broken: it was never reaching a search-aware
   * endpoint. Fixed to call the real one directly.
   */
  async list(search?: string): Promise<PermissionResponse[]> {
    const { data } = await api.get<PermissionResponse[]>("/api/hr/permissions", {
      params: { search: search?.trim() || undefined },
    });
    return data;
  },

  /**
   * Was PUT — the backend only maps these as POST (see PermissionController),
   * so every activate/deactivate click was silently failing with a 405 before
   * this fix.
   */
  async activate(id: number): Promise<PermissionResponse> {
    const { data } = await api.post<PermissionResponse>(
      `/api/hr/admin/permissions/${id}/activate`,
    );
    return data;
  },

  async deactivate(id: number): Promise<PermissionResponse> {
    const { data } = await api.post<PermissionResponse>(
      `/api/hr/admin/permissions/${id}/deactivate`,
    );
    return data;
  },
};
